"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOpeningGateway = exports.isFinishingPurchase = exports.getNFTPurchase = exports.getPendingManaPurchase = exports.getPendingPurchases = exports.getPurchases = exports.getError = exports.getLoading = exports.getData = exports.getState = void 0;
const selectors_1 = require("../loading/selectors");
const actions_1 = require("./actions");
const types_1 = require("./types");
const utils_1 = require("./utils");
const sortByTimestamp = (a, b) => a.timestamp > b.timestamp ? -1 : 1;
const getState = state => state.gateway;
exports.getState = getState;
const getData = (state) => (0, exports.getState)(state).data;
exports.getData = getData;
const getLoading = (state) => (0, exports.getState)(state).loading;
exports.getLoading = getLoading;
const getError = (state) => (0, exports.getState)(state).error;
exports.getError = getError;
const getPurchases = (state) => (0, exports.getData)(state).purchases;
exports.getPurchases = getPurchases;
const getPendingPurchases = (state) => (0, exports.getPurchases)(state).filter(purchase => purchase.status === types_1.PurchaseStatus.PENDING);
exports.getPendingPurchases = getPendingPurchases;
const getPendingManaPurchase = (state) => (0, exports.getPendingPurchases)(state).find(purchase => (0, utils_1.isManaPurchase)(purchase));
exports.getPendingManaPurchase = getPendingManaPurchase;
// In case a user buys an NFT multiple times (after selling it), the purchases are sorted by timestamp, so only the last purchase will be taken into account.
const getNFTPurchase = (state, contractAddress, tokenId) => {
    const nftPurchases = (0, exports.getPurchases)(state).filter(purchase => (0, utils_1.isNFTPurchase)(purchase));
    return nftPurchases
        .sort(sortByTimestamp)
        .find(({ nft }) => nft.contractAddress === contractAddress &&
        (nft.tokenId === tokenId || nft.itemId === tokenId));
};
exports.getNFTPurchase = getNFTPurchase;
const isFinishingPurchase = (state) => (0, selectors_1.isLoadingType)((0, exports.getLoading)(state), actions_1.MANA_FIAT_GATEWAY_PURCHASE_COMPLETED);
exports.isFinishingPurchase = isFinishingPurchase;
const isOpeningGateway = (state) => (0, selectors_1.isLoadingType)((0, exports.getLoading)(state), actions_1.OPEN_MANA_FIAT_GATEWAY_REQUEST);
exports.isOpeningGateway = isOpeningGateway;
//# sourceMappingURL=selectors.js.map